import React from 'react';
import './about.css';

function AboutContent({Icon,name}) {
    return (
        <div className="mini-flex">
            <div className="mini-flex-left">
                {Icon}
            </div>
            <div className="mini-flex-right">
                <h5>{name}</h5>
            </div>
        </div>
    )
}

export default AboutContent
